import { render, staticRenderFns } from "./Content.vue?vue&type=template&id=03631aa0&scoped=true"
import script from "./Content.vue?vue&type=script&lang=ts"
export * from "./Content.vue?vue&type=script&lang=ts"
import style0 from "./Content.vue?vue&type=style&index=0&id=03631aa0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03631aa0",
  null
  
)

export default component.exports